document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-card__figure').forEach(function(figure) {
    var jsonEl = figure.querySelector('.pc-images-data');
    if (!jsonEl) return;

    var images;
    try { images = JSON.parse(jsonEl.textContent); } catch(e) { return; }

    var mainImg = figure.querySelector('.product-card__image--primary');
    var secondaryImg = figure.querySelector('.product-card__image--secondary');
    var dots = figure.querySelectorAll('.pc-dot');
    var selected = 0;

    if (!mainImg || images.length < 2) return;

    // Preload all images immediately so clicks are instant
    images.forEach(function(imgData) {
      var preload = new Image();
      preload.src = imgData.src;
    });

    function setImage(index) {
      mainImg.src = images[index].src;
      mainImg.srcset = images[index].srcset;

      if (secondaryImg) {
        var nextIndex = (index + 1) % images.length;
        secondaryImg.src = images[nextIndex].src;
        secondaryImg.srcset = images[nextIndex].srcset;
      }

      dots.forEach(function(d, i) {
        d.classList.toggle('pc-dot--active', i === index);
      });
    }

    // Preload on hover so images are ready before any click
    figure.addEventListener('mouseenter', function() {
      images.forEach(function(imgData) {
        var preload = new Image();
        preload.src = imgData.src;
      });
    }, { once: true }); // only fires once per card

    figure.querySelector('.pc-arrow--prev').addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      selected = (selected - 1 + images.length) % images.length;
      setImage(selected);
    });

    figure.querySelector('.pc-arrow--next').addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      selected = (selected + 1) % images.length;
      setImage(selected);
    });

    figure.addEventListener('mouseleave', function() {
      selected = 0;
      setImage(0);
    });
  });
});